import { FiSearch, FiX } from "react-icons/fi";
import { LuSlidersHorizontal } from "react-icons/lu";

import {
  MINIMUM_SEARCH_TOKEN_LENGTH,
  isSearchQueryTooShort,
} from "@/utils/searchQueryValidation";

type BrowseSearchBarProps = {
  searchQuery: string;
  inputId?: string;
  inputName?: string;
  getCurrentFolderName?: () => string;
  placeholder?: string;
  onSearchChange: (value: string) => void;
  onClearSearch: () => void;
  onOpenAdvancedSearch?: () => void;
  showAdvancedSearchButton?: boolean;
  containerClassName?: string;
  inputClassName?: string;
};

const BrowseSearchBar = ({
  searchQuery,
  inputId,
  inputName,
  getCurrentFolderName,
  placeholder,
  onSearchChange,
  onClearSearch,
  onOpenAdvancedSearch,
  showAdvancedSearchButton = true,
  containerClassName,
  inputClassName,
}: BrowseSearchBarProps) => {
  const resolvedPlaceholder =
    placeholder || `Search ${getCurrentFolderName?.() || ""}`.trim();

  return (
    <div className={containerClassName || "relative max-w-md flex-1"}>
      <FiSearch
        className="absolute left-3 top-1/2 -translate-y-1/2 transform text-gray-400"
        size={18}
      />
      <input
        id={inputId}
        name={inputName}
        type="text"
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder={resolvedPlaceholder}
        className={
          inputClassName ||
          `w-full rounded-lg border border-gray-300 bg-white py-2 pl-10 text-sm focus:border-blue-500 focus:outline-none ${
            showAdvancedSearchButton ? "pr-20" : "pr-10"
          }`
        }
      />
      {searchQuery && (
        <button
          onClick={onClearSearch}
          className={`absolute top-1/2 -translate-y-1/2 transform rounded-full p-1 transition-colors hover:bg-gray-200 ${
            showAdvancedSearchButton ? "right-10" : "right-2"
          }`}
          title="Clear search"
        >
          <FiX size={16} className="text-gray-500" />
        </button>
      )}
      {showAdvancedSearchButton ? (
        <button
          onClick={onOpenAdvancedSearch}
          className="absolute right-2 top-1/2 -translate-y-1/2 transform rounded-full p-1.5 transition-colors hover:bg-gray-200 focus:outline-none"
          title="Advanced search"
        >
          <LuSlidersHorizontal size={16} className="text-gray-500" />
        </button>
      ) : null}
      {isSearchQueryTooShort(searchQuery) && (
        <p
          role="status"
          className="absolute left-0 top-full mt-1 text-xs text-gray-500"
        >
          Keep typing — each search term needs at least{" "}
          {MINIMUM_SEARCH_TOKEN_LENGTH} characters.
        </p>
      )}
    </div>
  );
};

export default BrowseSearchBar;
